import { useContext, useRef } from "react";
import { Header } from "../../../components/Landing/Header/haeder.view";
import { BannerJurados } from "../components/BannerJurados";
import { TextoInicialJurados } from "../components/TextoInicialJurados";
import { Footer } from "../../../components/Landing/Footer";
import { TextoinicialNumero } from "../components/TextoinicialNumero";
import { Row, Col, Input, Button, Form, Table, Empty, Modal, Popover, Divider } from "antd";
import { usePublicaciones } from "../../../hooks/usePublicaciones";
import { Modaleditarpublicaciones } from "./Modaleditarpublicaciones";
import { EyeOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { Modaleliminarpublicacion } from "./Modaleliminarpublicacion";
import { InputNumero } from "../../../components/Mascaras/InputNumero/InputNumero";
import { InputTexto } from "../../../components/Mascaras/InputTexto/InputTexto";
import { ModalVisualizarDocumentos } from "../../../components/Generales/ModalVisualizarDocumentos";
import moment from "moment";
import { useReactToPrint } from "react-to-print";
import { TemplateContext } from "../../../utils/template_context";
import DocumentInput from "../../../utils/DocumentInput";
import { useNavigate } from "react-router-dom";
import { UseVerConvocatorias } from "../../../hooks/UseVerConvocatorias";

export const Publicaciones = () => {
  const renderNavigate = useNavigate();
  const {
    getConvocatoriaPersistente,
    convocatoriaPersitente: convocatoria,
    setConvocatoriaPersitente,
    descargarArchivo,
  } = UseVerConvocatorias();
  const {
    publicacion,
    setPublicacion,
    publicaciones,
    setPublicaciones,
    agregarFila,
    modaleditar,
    setModaleditar,
    modaleliminar,
    setModaleliminar,
    setIndexpublicacion,
    guardarCamposModal,
    limpiarCampos,
    fileInputRef,
    guardarArchivo,
    nombrepublicacion,
    setNombrepublicacion,
    eliminarFila,
    continuarPublicaciones,
    modalvisualizardocumento,
    setModalVisualizarDocumento,
    documentovisualizar,
    setDocumentoVisualizar,
    indexpublicacion,
    openModal,
    setOpenModal,
  } = usePublicaciones();
  const context = useContext(TemplateContext);
  const AceptarModal = () => {
    setOpenModal(false);
  };
  const componentRef = useRef<any>();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    pageStyle:
      "pageStyles={'@media print { body { -webkit-print-color-adjust: exact; } @page { size: A4; margin: 200mm !important }}'}",
  });

  const columns: any = [
    {
      title: "No.",
      width: 60,
      render: (datos: any, datos2: any, index: number) => (
        <span>{index + 1}</span>
      ),
    },
    {
      title: "Título publicación",
      width: 200,
      dataIndex: "titulo_publicacion",
      key: "titulo_publicacion",
      fixed: context.device === "md" ? "left" : false,
      render: (datos: any) => {
        return datos.length > 27 ? (
          <Popover content={datos} title="Título publicación">
            {`${datos.substring(0, 27)}...`}
          </Popover>
        ) : (
          datos
        );
      },
    },
    {
      title: "Año",
      width: 100,
      dataIndex: "año",
      key: "año",
    },
    {
      title: "Ciudad",
      width: 100,
      dataIndex: "ciudad",
      key: "ciudad",
    },
    {
      title: "Anexar documento",
      width: 100,
      dataIndex: "documento",
      key: "documento",
    },
    {
      title: (
        <div className="row">
          <div className="col-12 d-flex justify-content-center">Acciones</div>
          <div className="col-4 text-center text-nowrap font-size-10px font-color-B0B0B0">
            Ver
          </div>
          <div className="col-4 text-center text-nowrap font-size-10px font-color-B0B0B0">
            Editar
          </div>
          <div className="col-4 text-center text-nowrap font-size-10px font-color-B0B0B0">
            Eliminar
          </div>
        </div>
      ),
      width: 150,
      render: (datos: any, datos2: any, index: number) => (
        <div className="row">
          <div className="col-4 text-center">
            <Button
              className="button-gray-ghost"
              icon={<EyeOutlined />}
              onClick={() => {
                setDocumentoVisualizar(datos.documento);
                return setModalVisualizarDocumento(true);
              }}
            ></Button>
          </div>
          <div className="col-4 text-center">
            <Button
              className="button-gray-ghost"
              onClick={() => {
                setPublicacion(datos);
                setIndexpublicacion(index);
                return setModaleditar(true);
              }}
              icon={<EditOutlined />}
            ></Button>
          </div>
          <div className="col-4 text-center">
            <Button
              className="color-delete button-gray-ghost"
              onClick={() => {
                setIndexpublicacion(index);
                setNombrepublicacion(datos.titulo_publicacion);
                return setModaleliminar(true);
              }}
              icon={<DeleteOutlined />}
            ></Button>
          </div>
        </div>
      ),
    },
  ];

  const fields = [
    { name: "titulo_publicacion", value: publicacion.titulo_publicacion },
    { name: "tema", value: publicacion.tema },
    { name: "ciudad", value: publicacion.ciudad },
    { name: "año", value: publicacion.año },
    { name: "descripcion", value: publicacion.descripcion },
    { name: "documento", value: publicacion.documento },
  ];

  return (
    <div>
      <Header />
      <BannerJurados BannerText="Banco de Jurados - Mis publicaciones" convocatorias={convocatoria}/>

      <div className="container-fluid2">
        <TextoInicialJurados
          TituloSpan="Agrega tus publicaciones."
          TitulosinSpan="(Este paso es opcional, si no cuentas con publicaciones haz clic en continuar)"
        />
      </div>

      <div className="container-fluid2">
        <div className="col-12 p-2">
          <div className="row">
            <TextoinicialNumero
              numero="8"
              textosinspan="Agregar tus publicaciones"
              textospan="Si deseas llenar este formulario recuerda que todos los campos son obligatorios"
              color="morado"
            />
          </div>
        </div>
      </div>

      <Form
        size="large"
        name="basic"
        onFinish={agregarFila}
        fields={fields}
        onFieldsChange={(_, fields: any) => {
          let infoupdate: any = { ...publicacion };
          console.log(fields);
          for (var i in fields) {
            infoupdate[fields[i].name] = fields[i].value;
          }
          setPublicacion(infoupdate);
        }}
      >
        <div className="container-fluid2">
          <div className="row">
            <div className="col-12 col-md-6 col-lg-6 mt-3">
              <span className="width-100 font-family-Montserrat-SemiBold font-size-12px container-span-titulos-bottom font-color-707070">
                Título de la publicación
              </span>
              <div>
                <div>
                  <Form.Item
                    className="no-margin"
                    name="titulo_publicacion"
                    rules={[{ required: true, message: "Campo obligatorio" }]}
                  >
                    <Input />
                  </Form.Item>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-3  mt-3">
              <span className="width-100 font-family-Montserrat-SemiBold font-size-12px container-span-titulos-bottom font-color-707070">
                Tema
              </span>
              <div>
                <div>
                  <Form.Item
                    className="no-margin"
                    name="tema"
                    rules={[{ required: true, message: "Campo obligatorio" }]}
                  >
                    <Input />
                  </Form.Item>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-3 mt-3">
              <span className="width-100 font-family-Montserrat-SemiBold font-size-12px container-span-titulos-bottom font-color-707070">
                Año
              </span>
              <div>
                <div>
                  <Form.Item
                    className="no-margin"
                    name="año"
                    rules={[
                      { required: true, message: "Campo obligatorio" },
                      { max: 4, message: "Máximo 4 números" },
                      { min: 4, message: "Mínimo 4 números" }
                    ]}
                  >
                    <InputNumero
                      name="año"
                      max={4}
                      texto={publicacion.año}
                      setTexto={setPublicacion}
                      alltexto={publicacion}
                      año={parseInt(moment().format("YYYY"))}
                    />
                  </Form.Item>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-6 mt-3">
              <span className="width-100 font-family-Montserrat-SemiBold font-size-12px container-span-titulos-bottom font-color-707070">
                Ciudad
              </span>
              <div>
                <div>
                  <Form.Item
                    className="no-margin"
                    name="ciudad"
                    rules={[{ required: true, message: "Campo obligatorio" }]}
                  >
                    <InputTexto
                      name="ciudad"
                      texto={publicacion.ciudad}
                      setTexto={setPublicacion}
                      alltexto={publicacion}
                    />
                  </Form.Item>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-6 mt-3">
              <span className="width-100 font-family-Montserrat-SemiBold font-size-12px container-span-titulos-bottom font-color-707070">
                Anexar documento
              </span>
              <Row>
                <Col span={24}>
                  <Form.Item className="no-margin" name="documento" rules={[{ required: true, message: "Documento obligatorio" }]}>
                    <DocumentInput
                      doc={publicacion.documento}
                      fileInputRef={fileInputRef}
                      ancho_btn={30}
                      on_change={(e) => {
                        guardarArchivo(e);
                        e.target.value = ""
                      }}
                      onDelete={() => {
                        setPublicacion({
                          ...publicacion,
                          documento: "",
                        });
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </div>
            <div className="col-12 mt-3">
              <span className="font-family-Montserrat-SemiBold no-margin pb-1 font-size-12px container-span-titulos-bottom font-color-707070">
                Breve descripción
              </span>

              <div>
                <Form.Item
                  className="no-margin"
                  name="descripcion"
                  rules={[{ required: true, message: "Campo obligatorio" }]}
                >
                  <Input.TextArea maxLength={250} showCount={true} />
                </Form.Item>
              </div>
            </div>
            <div className="col-12 d-flex justify-content-end align-items-end">
              <Button
                className="button-azul-ghost font-size-12px"
                onClick={limpiarCampos}
                style={{ marginBottom: '20px' }}
              >
                Limpiar campos
              </Button>
              <Button
                className="button-blanco-radius font-size-12px"
                htmlType="submit"
              >
                Agregar
              </Button>
            </div>
          </div>
          <div className="col-12 row-shadow-tablas">
            <Table
              pagination={false}
              title={() => "Mi lista de publicaciones"}
              dataSource={publicaciones}
              columns={columns}
              locale={{
                emptyText: (
                  <Empty
                    description="No has agregado ninguna publicación"
                    style={{ padding: "50px" }}
                  />
                ),
              }}
              size="large"
              bordered={false}
            />
          </div>
        </div>
        <div
          className="container-fluid2 bg-white"
          style={{
            justifyContent: "center",
            position: "sticky",
            bottom: 0,
            paddingBottom: "0%",
          }}
        >
          <div className="col justify-content-flex-end">
            <Button className="button-blanco-radius font-size-12px" style={{ marginRight: "16px" }} onClick={() => { return renderNavigate('/usuario/Reconocimientos') }}>Atrás</Button>
            <Button
              className="button-azul-radius font-size-12px"
              onClick={() => continuarPublicaciones()}
            >
              Continuar
            </Button>
          </div>
        </div>
      </Form>
      <Footer />
      <ModalVisualizarDocumentos
        state={{ documento: documentovisualizar }}
        visualizar={modalvisualizardocumento}
        setVisualizar={setModalVisualizarDocumento}
      />
      <Modaleditarpublicaciones
        publicacion={publicacion}
        setPublicacion={setPublicacion}
        publicaciones={publicaciones}
        setPublicaciones={setPublicaciones}
        modal={modaleditar}
        setModal={setModaleditar}
        guardarcambios={guardarCamposModal}
        limpiarcampos={limpiarCampos}
      />
      <Modaleliminarpublicacion
        modal={modaleliminar}
        nombre={nombrepublicacion}
        eliminar={() => eliminarFila(indexpublicacion)}
        cancelar={() => setModaleliminar(false)}
      />
      <div>
        <Modal
          style={{ top: 20, zIndex: 3, background: "transparent" }}
          visible={openModal}
          cancelButtonProps={{ style: { display: "none" } }}
          okButtonProps={{ style: { display: "none" } }}
          closable={false}
          closeIcon=""
          width={662}
          maskStyle={{
            zIndex: 3,
            background: "rgba(0,144,76,0.8)",
          }}
          className="modal-postulacion-exitosa"
        >
          <div className="row-shadow">
            <div className="row">
              <div className="col-12 font-size-22px font-family-Montserrat-Bold justify-content-center">
                Se ha completado el proceso
              </div>
              <div className="col-12 font-size-16px font-family-Montserrat-Regular justify-content-center">
                Felicidades te has postulado con éxito en la convocatoria:
              </div>
              <div className="col-12 font-size-16px font-family-Montserrat-SemiBold justify-content-center">
                Puede hacerle seguimiento desde el menú "Mis proyectos"
              </div>
            </div>
            <div className="row">
              <div
                className="justify-content-flex-end"
                style={{ paddingRight: "8px" }}
              >
                <Button className="button-blanco-radius" onClick={handlePrint}>
                  Descargar
                </Button>
              </div>
              <div
                className="justify-content-flex-end"
                style={{ textAlign: "initial", paddingLeft: "8px" }}
              >
                <Button className="button-azul-radius" onClick={AceptarModal}>
                  Aceptar
                </Button>
              </div>
            </div>
          </div>
          <div className="row-shadow">
            <div className="row">
              <div className="col-12 col-md-6">
                <div className="row">
                  <div className="col-12">
                    Código radicado:
                    <Divider />
                  </div>
                  <div className="col-12">
                    Nombre representante:
                    <Divider />
                  </div>
                  <div className="col-12">
                    Nombre del proyecto:
                    <Divider />
                  </div>
                  <div className="col-12">
                    Cédula/NIT:
                    <Divider />
                  </div>
                  <div className="col-12">
                    Fecha:
                    <Divider />
                  </div>
                  <div className="col-12">
                    Línea:
                    <Divider />
                  </div>
                  <div className="col-12">
                    Tipo participante:
                    <Divider />
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-6">
                <div className="row">
                  <div className="col-12">
                    <Divider />
                  </div>
                  <div
                    className="col-12"
                    style={{
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                    }}
                  >
                    <Divider />
                  </div>
                  <div
                    className="col-12"
                    style={{
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                    }}
                  >
                    <Divider />
                  </div>
                  <div
                    className="col-12"
                    style={{
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                    }}
                  >
                    <Divider />
                  </div>
                  <div
                    className="col-12"
                    style={{
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                    }}
                  >
                    <Divider />
                  </div>
                  <div
                    className="col-12"
                    style={{
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                    }}
                  >
                    <Divider />
                  </div>
                  <div className="col-12">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    </div>
  );
};
